var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorPage"},[_c('nio-header-nav',{attrs:{"position":"fixed","is-white":true,"height":_vm.headerHeight},on:{"update:height":function($event){_vm.headerHeight=$event},"back":_vm.backToLastPage}}),_c('span',{staticClass:"error_icon"}),_c('p',{staticClass:"error_text"},[_vm._v("你要找的页面不见啦！")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }